export const deriveDisplayUnitAmount = (rawPwycAmount: number, parentRowQuantity: number): number => {
  if (parentRowQuantity <= 0 || rawPwycAmount <= 0) {
    return rawPwycAmount;
  }
  return rawPwycAmount / parentRowQuantity;
};
